import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserSecret, faCogs, faChevronRight, faChartBar, faFolder, faHandHoldingUsd, faHandshake, faNewspaper, faBookOpen, faCoins, faShieldAlt, faBars, faHeadset, faCalendar, faCity, faCreditCard, faDownload, faFilter, faSearch } from '@fortawesome/free-solid-svg-icons'
import authAxios from "../services/Token";
import axios from "axios";
import Swal from 'sweetalert2';
import Submenu from './Submenu';
class Menu extends React.Component {
	constructor(props) {
		super(props);
	}
	state = {
		dolarText: '',
		Modulos: [],
		SubModulos: [],
		names: [],
	}
	modulos() {
		var idu = localStorage.getItem('idusuario');
		authAxios.get("roles/modulos/" + idu)
			.then((datosRespuesta) => {
				//console.log('Menu');
				//console.log(datosRespuesta.data);
				var status = datosRespuesta.data.status;
				if (status) {
					Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
					window.localStorage.clear();
					window.location.href = '/';
				}
				this.setState({ Modulos: datosRespuesta.data.data });
			})
			.catch(console.log);
	}
	dolarHoy() {
		let pesosESLocale = Intl.NumberFormat("es-ES");
		axios.get("https://s3.amazonaws.com/dolartoday/data.json")
			.then((datosRespuestaDolar) => {
				this.setState({ dolarText: '$ ' + pesosESLocale.format(datosRespuestaDolar.data.USDCOL.ratetrm) })
				window.localStorage.setItem('valorDolar', datosRespuestaDolar.data.USDCOL.ratetrm);
			})
	}
	componentDidMount() {
		this.modulos();
		//this.dolarHoy();
	}
	render() {
		const { Modulos, SubModulos, names, dolarText } = this.state;
		return (
			<div>
				<aside className="main-sidebar sidebar-dark-primary elevation-4">
					{/* Brand Logo */}
					<Link to="/home" className="brand-link">
						<img src={process.env.PUBLIC_URL + '/dist/img/AGM Desarrollos Logo.png'} className="brand-image img-circle elevation-3" style={{ opacity: '.8' }} />
						<span className="brand-text font-weight-light">Control AGM</span>
					</Link>
					{/* Sidebar */}
					<div className="sidebar">
						{/* Sidebar user panel (optional) */}
						<div className="user-panel mt-3 pb-3 mb-3 d-flex">
							<div className="image">
								<img src={process.env.PUBLIC_URL + '/dist/img/user2-160x160.jpg'} className="img-circle elevation-2" alt="User Image" />
							</div>
							<div style={{ color: "#C2C7D0" }} className="info">
                {window.localStorage.getItem('nombre')}
							</div>
						</div>
						{/* <div className="user-panel mt-3 pb-3 mb-3 d-flex">
							<div style={{ color: "#C2C7D0" }} className="info">
								Dolar Hoy:
							</div>
							<div style={{ color: "#C2C7D0" }} className="info">
								{dolarText}
							</div>
						</div> */}
						{/* Sidebar Menu */}
						<nav className="mt-2">
							<ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
								{/* 
									{
									Modulos.map((item) => (
										<li className="nav-item menu-close" key={item.id}>
										<a href="#" className="nav-link">
											<FontAwesomeIcon style={{ marginRight: 15 }} icon={
											//faUserSecret, faFolder, faUser, faBriefcase, faUserGraduate, faNetworkWired, faHeadset, faCashRegister, faCogs, faChevronRight, faShieldAlt
											item.icon === 'faUserSecret' ? faUserSecret :
												item.icon === 'faUser' ? faUser :
												item.icon === 'faBriefcase' ? faBriefcase :
													item.icon === 'faUserGraduate' ? faUserGraduate :
													item.icon === 'faNetworkWired' ? faNetworkWired :
														item.icon === 'faHeadset' ? faHeadset :
														item.icon === 'faCashRegister' ? faCashRegister :
															item.icon === 'faChevronRight' ? faChevronRight :
															item.icon === 'faShieldAlt' ? faShieldAlt :
																item.icon === 'faBars' ? faBars :
																item.icon === 'faCalendar' ? faCalendar :
																	item.icon === 'faCity' ? faCity :
																	item.icon === 'faCoins' ? faCoins :
																		item.icon === 'faCreditCard' ? faCreditCard :
																		item.icon === 'faDownload' ? faDownload :
																			item.icon === 'faFilter' ? faFilter :
																			item.icon === 'faCogs' ? faCogs : faFolder
											} />
											<p>

											{item.nombre}
											<i className="right fas fa-angle-left" />
											</p>
										</a>

										<ul className="nav nav-treeview" id={'submenu' + item.id}>


											<Submenu sub={item.id} />

										</ul>

										</li>
									))
									}*/}
								{Modulos.map((item, indexMenu) => (
									<li key={indexMenu} className="nav-item menu-close">
										<a href="#" className="nav-link">
											<FontAwesomeIcon style={{ marginRight: 15 }} icon={
												item.icon === 'faChartBar' ? faChartBar :
													item.icon === 'faHandHoldingUsd' ? faHandHoldingUsd :
														item.icon === 'faCoins' ? faCoins :
															item.icon === 'faHandshake' ? faHandshake :
																item.icon === 'faNewspaper' ? faNewspaper :
																	item.icon === 'faBookOpen' ? faBookOpen :
																		item.icon === 'faHeadset' ? faHeadset :
																			item.icon === 'faUserSecret' ? faUserSecret :
																				item.icon === 'faShieldAlt' ? faShieldAlt :
																					item.icon === 'faBars' ? faBars :
																						item.icon === 'faCalendar' ? faCalendar :
																							item.icon === 'faCity' ? faCity :
																								item.icon === 'faCoins' ? faCoins :
																									item.icon === 'faCreditCard' ? faCreditCard :
																										item.icon === 'faDownload' ? faDownload :
																											item.icon === 'faFilter' ? faFilter :
																												item.icon === 'faSearch' ? faSearch :
																													item.icon === 'faCogs' ? faCogs : faFolder
											} />
											<p>
												{item.nombre}
												<i className="right fas fa-angle-left" />
											</p>
										</a>
										<ul className="nav nav-treeview">
											{item.submenu.map((sub, indexSubMenu) => (
												<li key={indexSubMenu} className="nav-item">
													<Link to={"/" + sub.link} className="nav-link">
														<FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
														<p>{sub.titulo}</p>
													</Link>
												</li>
											))}
										</ul>
									</li>
								))}
								{/*                 <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faChartBar} />
                    <p>
                      Modelo Negocio
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/MasterCotizaciones" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Cotizaciones</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterContratos" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Flujo Financiero</p>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faHandHoldingUsd} />
                    <p>
                      Ingresos
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/MasterCargueLiquidaciones" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Cargue Oper. de Red</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterFactOperadoresRed" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Fact. Operadores de Red</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterFactComercializadores" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Fact. Comercializadoras</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterFactMunicipio" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Fact. Municipio (Esp.)</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterFactAportesMunicipales" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Fact. Aportes Munc.</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterClientesEspeciales" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Admin. Clientes Esp.</p>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faCoins} />
                    <p>
                      Egresos
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/MasterCargueOYMRI" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Cargue OYM - RI</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterRecaOperadoresRed" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Reca. Operadores de Red</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterRecaComercializadores" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Reca. Comercializadoras</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterRecaMunicipio" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Reca. Municipio (Esp.)</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterRecaAportesMunicipales" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Reca. Aportes Munc.</p>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faHandshake} />
                    <p>
                      Interventoría
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/MasterActasInterventoria" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Actas</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterLiquidacionesInterventoria" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Liquidaciones</p>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faNewspaper} />
                    <p>
                      Estado de Cuentas
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/MasterEstadoCuentas" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Estado Cuentas</p>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faBookOpen} />
                    <p>
                      Bitácoras
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/MasterBitacoraVisitas" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Visitas</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterMunicipiosLibreta" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Municipios</p>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faHeadset} />
                    <p>
                      P.Q.R.
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/MasterPQR" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>P.Q.R.</p>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faUserSecret} />
                    <p>
                      Administrador
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/MasterRoles" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Roles</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MasterUsuarios" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Usuario</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/MenuConfiguracion" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                        <p>Conf. Menu </p>
                      </Link>
                    </li>

                  </ul>
                </li>
                <li className="nav-item menu-close">
                  <a href="#" className="nav-link">
                    <FontAwesomeIcon style={{ marginRight: 15 }} icon={faCogs} />
                    <p>
                      Configuracion
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item menu-close">
                      <a href="#" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, fontSize: 10, marginLeft: 10 }} icon={faFolderOpen} />
                        <p>
                          Departamentos
                          <i className="right fas fa-angle-left" />
                        </p>
                      </a>
                      <ul className="nav nav-treeview">
                        <li className="nav-item">
                          <Link to="/MasterDepartamentosCargue" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Dpto. Cargue</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterDepartamentosVisita" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Dpto. Visita</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterDepartamentosOperadores" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Dpto. Oper. de Red</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterDepartamentosComercializadores" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Dpto. Comercializadoras</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item menu-close">
                      <a href="#" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, fontSize: 10, marginLeft: 10 }} icon={faFolderOpen} />
                        <p>
                          Municipios
                          <i className="right fas fa-angle-left" />
                        </p>
                      </a>
                      <ul className="nav nav-treeview">
                        <li className="nav-item">
                          <Link to="/MasterMunicipiosCargue" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Municipios Cargue</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterMunicipiosVisita" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Municipios Visita</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterMunicipiosOperadores" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Mun. Oper. de Red</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterMunicipiosComercializadores" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Mun. Comercializadoras</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item menu-close">
                      <a href="#" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, fontSize: 10, marginLeft: 10 }} icon={faFolderOpen} />
                        <p>
                          Ingresos
                          <i className="right fas fa-angle-left" />
                        </p>
                      </a>
                      <ul className="nav nav-treeview">
                        <li className="nav-item">
                          <Link to="/MasterOperadores" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Operadores de Red</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterComercializadores" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Comercializadoras</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item menu-close">
                      <a href="#" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, fontSize: 10, marginLeft: 10 }} icon={faFolderOpen} />
                        <p>
                          Modelo Negocio
                          <i className="right fas fa-angle-left" />
                        </p>
                      </a>
                      <ul className="nav nav-treeview">
                        <li className="nav-item">
                          <Link to="/MasterCapitulos" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Categorías</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterProductos" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Lista Productos (APU)</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterMateriales" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Materiales</p>
                          </Link>
                        </li>
                        {/*<li className="nav-item">
                          <Link to="/MasterEquipos" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Equipos</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterUCAPS" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Und. Constructivas</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item menu-close">
                      <a href="#" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, fontSize: 10, marginLeft: 10 }} icon={faFolderOpen} />
                        <p>
                          Personas
                          <i className="right fas fa-angle-left" />
                        </p>
                      </a>
                      <ul className="nav nav-treeview">
                        <li className="nav-item">
                          <Link to="/MasterAlcaldias" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Alcaldías</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterContribuyentes" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Contribuyentes</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterConcesiones" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Concesiones</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterEmpresas" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Empresas</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="nav-item menu-close">
                      <a href="#" className="nav-link">
                        <FontAwesomeIcon style={{ marginRight: 15, fontSize: 10, marginLeft: 10 }} icon={faFolderOpen} />
                        <p>
                          Parámetros
                          <i className="right fas fa-angle-left" />
                        </p>
                      </a>
                      <ul className="nav nav-treeview">
                        <li className="nav-item">
                          <Link to="/MasterTipoClientes" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Tipos de Cliente</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterTarifas" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Tarifas</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterTipoNovedades" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Tipo de Novedades</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterEstadosSuministros" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Estados Suministro</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterTipoVisitas" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Tipo de Visitas</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/MasterTipoContratos" className="nav-link">
                            <FontAwesomeIcon style={{ marginRight: 15, marginLeft: 10, fontSize: 10 }} icon={faChevronRight} />
                            <p>Tipo de Contratos</p>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li> */}
							</ul>
						</nav>
						{/* /.sidebar-menu */}
					</div>
					{/* /.sidebar */}
				</aside>
			</div>
		)
	}
}

export default Menu;